export const CATEGORIES = {
  BEWONERSIDEE: "Bewonersidee",
  VERENIGINGSIDEE: "Verenigingsidee",
  DISTRICTSIDEE: "Districtsidee",
};

export const DISTRICTSBREED = "Districtsbreed";

// Projects without a photo fall back to the greyscale Burgerbegroting label,
// padded to the same 700x394 frame as the real project images so the cards'
// `object-fit: cover` neither crops nor upscales the wordmark.
export const PLACEHOLDER_IMAGE = "/placeholder.png";

/**
 * @typedef {Object} Project
 * @property {string} id - matches `project_slug` in the aggregator ranking
 * @property {number} topic_id - bpart topic, one per category
 * @property {number} entry_id - bpart entry, unique across topics
 * @property {string} link - public project page, `{BPART_URL}/topics/{topic_id}/entries/{entry_id}`
 * @property {"Bewonersidee" | "Verenigingsidee" | "Districtsidee"} category
 * @property {number} budget - max 6 digits
 * @property {string} postcode - 4-digit postcode or "Districtsbreed"
 * @property {string} title
 * @property {string} description
 * @property {string} image - URL to the project image
 */

/** @type {Project[]} */
export const PROJECTS = [
  {
    id: "2060-straatparty",
    topic_id: 4645,
    entry_id: 87407,
    link: "https://burgerbegroting.be/topics/4645/entries/87407",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 40920,
    postcode: "2060",
    title: "2060 Straatparty",
    description:
      "2060 Straatparty wil meer straatfeesten in de wijken Dam en Stuivenberg. Daarom organiseert Elegast vzw samen met bewoners 12 nieuwe straatfeesten in straten waar die nog ontbreken. Ook andere straten krijgen ondersteuning bij hun aanvraag en kunnen gebruikmaken van een springkasteel, mobiele keuken en muziekinstallatie. Samen koken, eten en vieren brengt buren samen. Elke straat een feest! Met 14.000€ personeelskost.",
    image: "/projects/V 2060 Straatparty.jpg",
  },
  {
    id: "abc-botanica",
    topic_id: 4645,
    entry_id: 87408,
    link: "https://burgerbegroting.be/topics/4645/entries/87408",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 150000,
    postcode: "2060",
    title: "ABC Botanica",
    description:
      "ABC Botanica maakt van ’t Hofke van Stuivenberg een open leertuin waar jong en oud al doende en op een laagdrempelige manier kennis maken met natuur, voedsel en ecologie. Door samen te tuinieren en te delen groeit niet alleen het groen, maar ook de verbondenheid en toegang tot natuur in de buurt. Dit zorgt voor een rustplek voor bewoners, en tegelijk groeit het bewustzijn rond ecologie en stadsnatuur. Met € 140.000 personeelskost voor 2 jaar.",
    image: "/projects/V ABC Botanica.jpeg",
  },
  {
    id: "antwerpen-een-veerkrachtige-stad",
    topic_id: 4645,
    entry_id: 87409,
    link: "https://burgerbegroting.be/topics/4645/entries/87409",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 28760,
    postcode: "2020, 2060",
    title: "Antwerpen, een veerkrachtige stad",
    description:
      "De Verhalenwerf vzw en intercultureel netwerk Broedplaats brengen oude en nieuwe Antwerpenaren samen om verhalen, gedichten, foto’s en illustraties over veerkracht te verzamelen, creëren en delen. In vijf Antwerpse wijken gaan bewoners met elkaar in gesprek en werken ze samen aan inspirerende getuigenissen. In 20 salons, 6 vertelmomenten en posters in de publieke ruimte wordt de veerkracht van Antwerpen zichtbaar voor een breed publiek.",
    image: "/projects/V Antwerpen een veerkrachtige stad.jpg",
  },
  {
    id: "atelier-faar",
    topic_id: 4645,
    entry_id: 87517,
    link: "https://burgerbegroting.be/topics/4645/entries/87517",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 85789,
    postcode: "2000",
    title: "Atelier FAAR",
    description:
      "Kunstenaarscollectief FAAR vzw wil van hun onlangs verworven pand aan de Italiëlei een bruisende en toegankelijke artistieke plaats maken waar iedereen welkom is. Een plek waar kunst en muziek worden gemaakt en gedeeld, met openbare evenementen zoals expo’s, concerten, filmavonden en buurtfeesten. We investeren in een degelijke, multifunctionele en inclusieve zaal waarin artiesten van binnen en buiten de stad een podium krijgen.",
    image: "/projects/V Atelier FAAR.jpg",
  },
  {
    id: "binnenpleinen-manchesterlaan-vernieuwen",
    topic_id: 4648,
    entry_id: 87360,
    link: "https://burgerbegroting.be/topics/4648/entries/87360",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 180000,
    postcode: "2030",
    title: "Binnenpleinen Manchesterlaan vernieuwen",
    description:
      "Vervang dolomiet door een aangename (half)verharding. De binnenpleinen aan de Manchesterlaan zijn nu stoffig bij zon en modderig bij regen. Dit voorstel maakt er een prettige plek van om te wandelen, zitten en kijken voor bewoners.",
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: "bloemen-op-rond-punt-walvisstraat",
    topic_id: 4648,
    entry_id: 87361,
    link: "https://burgerbegroting.be/topics/4648/entries/87361",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 15000,
    postcode: "2018",
    title: "Bloemen op rond punt Walvisstraat",
    description:
      "Op het rondpunt van de Lange Van Ruusbroecstraat, Raafstraat en Walvisstraat staat een boom met een ladder als kunstwerk. Rondom ligt nu enkel gras. Door dit om te vormen tot een bloemenperk kan de buurt er maandenlang van genieten.",
    image: "/projects/D Bloemen op rondpunt walvis.jpg",
  },
  {
    id: "boekenkaravaan-voorleesfiets-in-de-buurt",
    topic_id: 4645,
    entry_id: 87464,
    link: "https://burgerbegroting.be/topics/4645/entries/87464",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 148793,
    postcode: DISTRICTSBREED,
    title: "Boekenkaravaan, voorleesfiets in de buurt",
    description:
      "De Voorleesfiets van Boekenkaravaan brengt verhalen tot in de straten van de wijk. De fiets stopt aan voordeuren, op pleinen, bij scholen, verenigingen en buurtfeesten. Zo brengt de Schoolbrug vzw lees- en voorleesplezier dichtbij en versterkt taalvaardigheid, buurtverbinding en vrijwilligerswerk. In samenwerking met lokale organisaties kan dit initiatief uitgroeien tot een aanbod voor het hele district. Met 135.743€ personeelskost voor 2 jaar.",
    image: "/projects/V Boekenkaravaan, voorleesfiets in de buurt.jpg",
  },
  {
    id: "brave-move",
    topic_id: 4645,
    entry_id: 87642,
    link: "https://burgerbegroting.be/topics/4645/entries/87642",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 150000,
    postcode: "2060",
    title: "BRAVE move",
    description:
      "Met BRAVE-Move in Antwerpen Noord brengt Kras Jeugdwerk tienermeisjes samen via sport en beweging en helpt hen de publieke ruimte stap voor stap in te nemen, op hun eigen manier en tempo. Meisjes denken mee, organiseren activiteiten en krijgen coaching om te groeien tot initiatiefnemers en rolmodellen. Zo creëren ze een veilige, levendige omgeving én krijgen ze verbinding met het sportaanbod in de stad. Met € 105.000 personeelskost voor 2 jaar.",
    image: "/projects/V Brave Move.jpg",
  },
  {
    id: "buiten-spelen",
    topic_id: 4648,
    entry_id: 87503,
    link: "https://burgerbegroting.be/topics/4648/entries/87503",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 50000,
    postcode: "2050",
    title: "Buiten spelen!",
    description:
      "Een kleine kunststof halfpipe aan de terreinen van de Klimoever school op Linkeroever kan de buurt een stuk leuker maken voor kinderen die skaten, steppen of rolschaatsen. De ramp is geschikt voor beginners maar laat ook groei toe. Zo stimuleren we buitenspelen, sport en sociaal contact in de buurt.",
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: "buurtcinema-linkeroever",
    topic_id: 4645,
    entry_id: 87465,
    link: "https://burgerbegroting.be/topics/4645/entries/87465",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 34514,
    postcode: "2050",
    title: "Buurtcinema Linkeroever",
    description:
      "​​Film op een unieke locatie: in de kleine of grote zaal van de kerk op Linkeroever. Het aanbod omvat zowel publieksfilms als arthousecinema met artistieke meerwaarde en inhoudelijke diepgang. Daarnaast zijn er documentaires en jeugdfilms voor scholen en jonge kinderen, vaak gekoppeld aan workshops, lezingen of lessen Nederlands. ​Door Anna 3 vzw. ",
    image: "/projects/V Buurtcinema LO.jpg",
  },
  {
    id: "buurtgerichte-oudergroepen-2018",
    topic_id: 4647,
    entry_id: 86921,
    link: "https://burgerbegroting.be/topics/4647/entries/86921",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 7500,
    postcode: "2018",
    title: "Buurtgerichte oudergroepen 2018",
    description:
      "Ouders komen maandelijks samen rond thema’s die zij belangrijk vinden. Onder begeleiding delen ze ervaringen uit verschillende culturen en verkennen samen oplossingen en nieuwe inzichten. Dit versterkt hun zelfvertrouwen en opvoedingsvaardigheden, en geeft kinderen een warme, sterke basis om op te groeien.",
    image: "/projects/B Buurtgerichte oudergroepen.jpg",
  },
  {
    id: "carrousel-2-0-openluchttheater",
    topic_id: 4648,
    entry_id: 87638,
    link: "https://burgerbegroting.be/topics/4648/entries/87638",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 150000,
    postcode: DISTRICTSBREED,
    title: "Carrousel 2.0 Openluchttheater",
    description:
      "​​De Carrousel, een rond en verplaatsbaar openluchttheater dat tijdens de coronaperiode op de kaaien stond, wordt gedurende zes maanden opnieuw ingezet in het district Antwerpen. Het biedt ruimte voor kleinschalige cultuurevenementen via maandelijkse programmatie en verhuur, eventueel in samenwerking met Zomer van Antwerpen. Voor de uitvoering wordt € 80.000 voorzien aan personeelskosten voor één jaar.​",
    image: "/projects/D Carrousel 2.0 Openluchttheater.jpg",
  },
  {
    id: "creatieve-kids-in-pecherpakhuis",
    topic_id: 4647,
    entry_id: 87457,
    link: "https://burgerbegroting.be/topics/4647/entries/87457",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 4070,
    postcode: "2000",
    title: "Creatieve Kids in Pecherpakhuis",
    description:
      "Creatieve ouders en grootouders begeleiden acht workshops met 10 kinderen (4-8 jaar) uit de buurt en maken kunstwerkjes met bijvoorbeeld klei, flessen, karton of afval dat in de buurt tijdens een wandeling wordt verzameld. In de Pecherstraat wordt een magazijntje hiervoor opengesteld.",
    image: "/projects/B Creatieve Kids in Pecherpakhuis.jpeg",
  },
  {
    id: "cricket-in-park-spoor-noord",
    topic_id: 4648,
    entry_id: 87504,
    link: "https://burgerbegroting.be/topics/4648/entries/87504",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 60000,
    postcode: "2060",
    title: "Cricket in Park Spoor Noord",
    description:
      "In park Spoor Noord wordt al geruime tijd cricket beoefend door een grote groep jongeren. Een echt cricketveld is moeilijk te vinden, maar dit project zorgt ervoor dat de sport op een veiligere manier kan beoefend worden, door enkele hekken bij te plaatsen en de ondergrond te verbeteren.",
    image: "/projects/D Cricket in Park Spoor Noord.jpg",
  },
  {
    id: "culture-club-een-cultuurhuis-op-linkeroever",
    topic_id: 4645,
    entry_id: 87637,
    link: "https://burgerbegroting.be/topics/4645/entries/87637",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 38920,
    postcode: "2050",
    title: "Culture Club: een cultuurhuis op Linkeroever",
    description:
      "Met Culture Club creëert Stichting Vicariaat Antwerpen een creatieve ontmoetingsplek op Linkeroever. Kunstenaars begeleiden twee keer per week ateliers en workshops voor jongere en oudere bewoners van Europark, gecombineerd met gezamenlijke maaltijden. De ambitie is om ook bewoners uit Regatta, Sint-Anna en andere buurten te betrekken. Twee jaar lang staat een warme plek voor ontmoeting, creativiteit en verbinding centraal.",
    image: "/projects/V Culture Club.jpeg",
  },
  {
    id: "de-groene-poort",
    topic_id: 4648,
    entry_id: 87363,
    link: "https://burgerbegroting.be/topics/4648/entries/87363",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 418000,
    postcode: "2018",
    title: "De groene poort",
    description:
      "Ontharding en vergroening van de Nottebohmstraat met bomen en lage begroeiing.",
    image: "/projects/D De groene poort.jpg",
  },
  {
    id: "de-lepelstraat-in-bloei",
    topic_id: 4647,
    entry_id: 87593,
    link: "https://burgerbegroting.be/topics/4647/entries/87593",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 7500,
    postcode: "2000",
    title: "De Lepelstraat in bloei",
    description:
      "We vergroenen de Willem Lepelstraat (2000 Antwerpen) met duurzame plantenbakken, bloemen en een zitplek. Het project versterkt sociale cohesie en brengt bewoners samen. We betrekken buren actief bij plaatsing en onderhoud en creëren een toegankelijke groene ontmoetingsplek voor iedereen.",
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: "de-mobiele-luisterpaal-verbindt-2060",
    topic_id: 4645,
    entry_id: 87410,
    link: "https://burgerbegroting.be/topics/4645/entries/87410",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 99500,
    postcode: "2060",
    title: "De Mobiele Luisterpaal verbindt 2060",
    description:
      "​​De Luisterpaal is een rondtrekkend audiovisueel kunstwerk dat door 2060 reist. 2060 United vzw verzamelt positieve verhalen die zelden in de media verschijnen en brengt bewoners in gesprek over lokale thema’s. Via een website en drukwerk worden getuigenissen en gesprekken breed gedeeld. Zo ontstaat een sociale infrastructuur van ontmoeting, verbinding en uitwisseling, gedragen door verenigingen en bewoners. Met 61.000€ personeelskost voor 2 jaar.",
    image: "/projects/V De Mobiele Luisterpaal verbindt 2060.jpg",
  },
  {
    id: "de-reizende-kinderkeuken-het-smakencircus",
    topic_id: 4645,
    entry_id: 87411,
    link: "https://burgerbegroting.be/topics/4645/entries/87411",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 132000,
    postcode: DISTRICTSBREED,
    title: "De reizende kinderkeuken: het smakencircus",
    description:
      "De Reizende Kinderkeuken brengt gezonde, duurzame voeding tot bij kinderen en gezinnen in Antwerpse buurten. Via mobiele kookateliers op toegankelijke ontmoetingsplaatsen maken deelnemers kennis met culinair erfgoed, lokale ingrediënten en toekomstgerichte voeding. Speelvogel vzw stimuleert ontmoeting, voedselbewustzijn en sociale cohesie door samen te koken, proeven, ontdekken en verhalen te delen. Met 90.000€ personeelskost in 2 jaar.",
    image: "/projects/V De reizende kinderkeuken, het smakencircus.jpg",
  },
  {
    id: "deelmunten-voor-vrijwilligers",
    topic_id: 4648,
    entry_id: 87518,
    link: "https://burgerbegroting.be/topics/4648/entries/87518",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 33500,
    postcode: "2018",
    title: "Deelmunten voor vrijwilligers",
    description:
      "Organisaties in 2018 waarderen hun vrijwilligers via een deelmunt die zij kunnen besteden bij verschillende deelnemende partners: deelname aan activiteiten, zoals een atelier bij De Markgrave, consumpties zoals een koffie of maaltijd bij Lucy’s of Hof ter Beke. Dit systeem stimuleert niet alleen de waardering van vrijwilligers, maar bevordert ook de onderlinge verbinding tussen organisaties. Met 14.500€ personeelskost voor 3 jaar.",
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: "delicious-dishes",
    topic_id: 4645,
    entry_id: 87321,
    link: "https://burgerbegroting.be/topics/4645/entries/87321",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 32400,
    postcode: "2018",
    title: "Delicious Dishes",
    description:
      "Twee jaar lang komen 60-plussers maandelijks samen om delicatessen uit verschillende landen en culturen te koken en te proeven gevolgd door een lichte lunch en een gezamenlijke activiteit. Vrijwilligers van Yachdov vzw zorgen voor het vervoer van mensen met een beperking.",
    image: "/projects/V Delicious Dishes.jpg",
  },
  {
    id: "een-bakfiets-voor-de-deugnieten",
    topic_id: 4647,
    entry_id: 87505,
    link: "https://burgerbegroting.be/topics/4647/entries/87505",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 3500,
    postcode: "2060",
    title: "Een bakfiets voor de Deugnieten",
    description:
      "De Deugnieten FV organiseert huiswerkbegeleiding, kinderkampjes en voetbal voor kinderen in 2060. Voor hun activiteiten willen ze een bakfiets kopen zodat ze boodschappen kunnen vervoeren, voeding en drank, en speel- en sportmateriaal.",
    image: "/projects/B Een bakfiets voor de Deugnieten.jpeg",
  },
  {
    id: "een-buurthuisje-met-keuken-in-de-seefhoek",
    topic_id: 4645,
    entry_id: 87413,
    link: "https://burgerbegroting.be/topics/4645/entries/87413",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 60000,
    postcode: "2060",
    title: "Een buurthuisje met keuken in de Seefhoek",
    description:
      "Buurtbewoners van de Amanduswijk (Amandus 2060 vzw) willen de oude pastorij omvormen tot een buurthuisje met keuken en gezellige tuin, open voor de hele buurt. Het wordt een plek voor volkskeukens, buurtfeesten, workshops en andere verbindende activiteiten. Dankzij een rechtstreekse toegang is het buurthuisje in de zomer ook een chilltuin. De ruimte staat ter beschikking van buurtbewoners en organisaties. Met € 2.500 personeelskost.",
    image: "/projects/V Een buurthuisje met keuken in de Seefhoek.jpg",
  },
  {
    id: "een-drinkfontein-op-linkeroever-amo",
    topic_id: 4648,
    entry_id: 87466,
    link: "https://burgerbegroting.be/topics/4648/entries/87466",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 12000,
    postcode: "2050",
    title: "Een drinkfontein op Linkeroever (AMO)",
    description:
      "Een drinkfontein op Linkeroever waar iedereen gratis water kan drinken, ter herinnering en als eerbetoon aan Mohammed Kourrich die zich tijdens zijn leven sterk inzette voor de bewoners van Europark.",
    image: "/projects/D Een drinkfontein op Linkeroever (AMO).jpg",
  },
  {
    id: "een-groener-terrein-voor-chiro-lore-tegen-overlast",
    topic_id: 4645,
    entry_id: 87520,
    link: "https://burgerbegroting.be/topics/4645/entries/87520",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 20000,
    postcode: "2018",
    title: "Een groener terrein voor Chiro Lore tegen overlast",
    description:
      "Chiro Lore ligt in een woonwijk, waardoor activiteiten en verhuur van lokalen soms overlast veroorzaken. Vergroening van het terrein met bomen en nieuw gras zal dit beperken. Bomen dempen geluid, het grasveld maakt spelen veiliger en aangenamer. Zo verbetert de leefkwaliteit in de buurt en ontstaat een duurzame groene plek voor jeugd.",
    image: "/projects/V Een groener terrein voor Chiro Lore tegen overlast.jpg",
  },
  {
    id: "een-hondenloopzone-op-linkeroever",
    topic_id: 4648,
    entry_id: 87521,
    link: "https://burgerbegroting.be/topics/4648/entries/87521",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 75000,
    postcode: "2050",
    title: "Een hondenloopzone op Linkeroever",
    description:
      "Aanleg van een nieuwe hondenloopzone op Linkeroever of maximale opwaardering van een bestaande hondenloopzone. Met veilige, hoge omheining, een sas en zelfsluitende poorten. Aangevuld met speeltuigen voor honden, bomen voor schaduw, zitbanken en vuilbakken.",
    image: "/projects/D Een hondenloopzone op Linkeroever.jpg",
  },
  {
    id: "een-nieuwe-gevel-en-huiskamer-voor-het-bos",
    topic_id: 4645,
    entry_id: 87322,
    link: "https://burgerbegroting.be/topics/4645/entries/87322",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 132427,
    postcode: "2000",
    title: "Een nieuwe gevel en huiskamer voor Het Bos",
    description:
      "Iedereen welkom in jeugd- en kunstencentrum Het Bos: een open huis om te ontmoeten, samen te eten en te coworken met gratis koffie! We investeren in een warm onthaal, uitnodigende gevel en bewegwijzering voor duidelijke communicatie naar bezoekers. De Bosbar toveren we (met enthousiaste vrijwilligers) om tot een warme huiskamer met nieuwe tafels en zetels, maar ook met goede akoestiek en sfeervol licht. Met 23.844€ personeelskost voor 2 jaar.",
    image: "/projects/V Een nieuwe gevel en warme huiskamer voor Het Bos.jpg",
  },
  {
    id: "een-thuis-voor-de-toekomst-in-luchtbal",
    topic_id: 4647,
    entry_id: 86923,
    link: "https://burgerbegroting.be/topics/4647/entries/86923",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 7500,
    postcode: "2030",
    title: "Een thuis voor De Toekomst in Luchtbal",
    description:
      "​​De Toekomst FV bouwt stap voor stap een nieuwe ontmoetings- en activiteitenruimte uit voor jongeren en ouderen uit de buurt. Samen met vrijwilligers ontstaat een aanbod aan activiteiten dat ontmoeting, sociale verbinding en ontspanning stimuleert. Luchtbal heeft dit nodig!​",
    image: "/projects/B Een thuis voor De Toekomst in Luchtbal.jpg",
  },
  {
    id: "ehbo-kit",
    topic_id: 4647,
    entry_id: 87401,
    link: "https://burgerbegroting.be/topics/4647/entries/87401",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 900,
    postcode: DISTRICTSBREED,
    title: "EHBO kit",
    description:
      "​Neos-Antwerpen organiseert regelmatig wandelingen en activiteiten voor meer dan 400 senioren. Door de grote opkomst wordt voortaan in twee groepen gewandeld. Tijdens eerdere activiteiten deden zich enkele kleine incidenten voor. Twee goed uitgeruste EHBO-rugzakken verhogen de veiligheid en maken het mogelijk om snel en gepast te reageren wanneer nodig.",
    image: "/projects/B EHBO kit.jpg",
  },
  {
    id: "extra-activiteiten-voor-jongeren",
    topic_id: 4648,
    entry_id: 87545,
    link: "https://burgerbegroting.be/topics/4648/entries/87545",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 63000,
    postcode: DISTRICTSBREED,
    title: "Extra activiteiten voor jongeren",
    description:
      "14 jeugdwerkingen in Antwerpen organiseren 3 jaar lang extra activiteiten die jongeren zelf mee vormgeven. Zij krijgen een budget, om met begeleiding, workshops en activiteiten te kiezen die aansluiten bij hun interesses en noden. Zo versterken ze praktische, creatieve, studie- en werkgerelateerde vaardigheden en nemen ze actief eigenaarschap op binnen hun jeugdwerking. Dit is een idee van de jeugdraad van district Antwerpen.",
    image: "/projects/D Extra activiteiten - opleidingen in jeugdhuizen.jpg",
  },
  {
    id: "familiefestival-kiel",
    topic_id: 4647,
    entry_id: 86925,
    link: "https://burgerbegroting.be/topics/4647/entries/86925",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 7500,
    postcode: "2020",
    title: "Familiefestival Kiel",
    description:
      "​​Familiefestival in het Kielpark met een multiculturele muzikale namiddag voor jong en oud. Bezoekers van alle leeftijden en achtergronden zijn welkom. Buurtorganisaties en verenigingen krijgen een eigen plek op het festival en worden mee betrokken.​ Door FV Hoop Kiel.",
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: "feeerieke-boom",
    topic_id: 4647,
    entry_id: 87639,
    link: "https://burgerbegroting.be/topics/4647/entries/87639",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 6280,
    postcode: "2020",
    title: "Feeërieke boom",
    description:
      "​Een boom aan de bibliotheek op het Kiel krijgt een winterse, feeërieke make-over met sfeervolle verlichting. Tijdens de feestelijke ontsteking brengt een woordkunstenaar een passende tekst. De magische uitstraling zorgt voor ontmoeting en verbinding in de buurt en keert elke avond terug. Rond kerst volgt een tweede buurtverbindend evenement bij de boom. Inclusief € 2.500 personeelskosten.",
    image: "/projects/B Feeërieke Boom.jpg",
  },
  {
    id: "fietsatelier-en-uitleendienst-luchtbal",
    topic_id: 4647,
    entry_id: 86936,
    link: "https://burgerbegroting.be/topics/4647/entries/86936",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 4000,
    postcode: "2030",
    title: "Fietsatelier en uitleendienst Luchtbal",
    description:
      "De Maatschappij fv biedt gratis kleine fietsherstellingen aan voor de bewoners van Luchtbal. Onderdelen moeten zelf meegebracht worden. Kinderen tot en met 18 jaar met een doorverwijzingsbrief van het Huis van het Kind of OCMW die de onderdelen niet kunnen betalen, krijgen deze gratis. Buurtbewoners kunnen ook kosteloos werkmateriaal lenen.",
    image: "/projects/B Fietsatelier en uitleendienst Luchtbal.jpg",
  },
  {
    id: "film-event-over-het-de-coninckplein",
    topic_id: 4645,
    entry_id: 87522,
    link: "https://burgerbegroting.be/topics/4645/entries/87522",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 49850,
    postcode: "2060",
    title: "Film & Event over het De Coninckplein",
    description:
      "Cameltown vzw maakt samen met het Vlot, Permeke, Bad van Marie & Free Clinic een film over en met de mensen en plekken rond het De Coninckplein. Met € 36.750 personeelskost.",
    image: "/projects/V Film & Event over het De Coninckplein.jpg",
  },
  {
    id: "forbidden-city-maakt-lokaal-talent-zichtbaar",
    topic_id: 4645,
    entry_id: 87414,
    link: "https://burgerbegroting.be/topics/4645/entries/87414",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 36241,
    postcode: "2000",
    title: "Forbidden City maakt lokaal talent zichtbaar",
    description:
      "Forbidden City geeft jonge makers een podium en maakt lokaal talent zichtbaar. Met minstens 18 toegankelijke toonmomenten en mini-residenties in de zomer kunnen kunstenaars experimenteren en stimuleert Platitude vzw uitwisseling en ontmoeting met de buurt.",
    image: "/projects/V Forbidden City maakt lokaal talent zichtbaar.jpeg",
  },
  {
    id: "groene-feeen",
    topic_id: 4647,
    entry_id: 87467,
    link: "https://burgerbegroting.be/topics/4647/entries/87467",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 7500,
    postcode: "2060",
    title: "Groene Feeën",
    description:
      "De Groene Feeën ondersteunen bewoners bij het onderhouden en vernieuwen van aanplantingen in en rond de Pothoek- en Kerkstraat. Via de Burgerbegroting werden tal van groenelementen aangelegd. Waar extra zorg nodig is, gebeuren snoeiwerken en worden planten of grond vernieuwd, steeds in overleg met bewoners. Het project omvat 33 geveltuinen, 9 plantvakken, 23 boomspiegels, 5 plantbakken, 2 groene zitbanken en 7 regentonnen.",
    image: "/projects/B Groene Feeën.jpg",
  },
  {
    id: "groene-hoek-rembrandt-florisstraat",
    topic_id: 4648,
    entry_id: 87458,
    link: "https://burgerbegroting.be/topics/4648/entries/87458",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 65000,
    postcode: "2018",
    title: "Groene hoek Rembrandt-Florisstraat",
    description:
      "Het pleintje voor de beschermde historische gevel (1876) wordt vergroend met halfhoge struiken en bloemen, aangevuld met één of meerdere bomen. Een zitbank zorgt voor extra verblijfskwaliteit. Door het ontharden en vergroenen van de stoep ontstaat ook een natuurlijke barrière tegen foutparkeren. Zo krijgt de buurt een aangenamere en groenere uitstraling.",
    image: "/projects/D Groene hoek Rembrandt- en Florisstraat.jpeg",
  },
  {
    id: "het-kiel-rocks",
    topic_id: 4648,
    entry_id: 87523,
    link: "https://burgerbegroting.be/topics/4648/entries/87523",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 183000,
    postcode: "2020",
    title: "Het Kiel Rocks",
    description:
      "'t Kiel Rocks brengt boulderen naar het Kiel en maakt de sport toegankelijk voor de buurt. In en rond het park komen zes granieten klimblokken en picknicktafels die het straatbeeld verfraaien. De indrukwekkende blokken nodigen uit om te klimmen én te ontmoeten. Klimvereniging Bergsportvereniging Provincie Antwerpen vzw, gevestigd in de Sint-Catharinakerk, zorgt voor begeleiding en valmatten zodat iedereen veilig kan deelnemen.",
    image: "/projects/D Het Kiel Rocks.jpg",
  },
  {
    id: "iedereen-verdient-een-podium",
    topic_id: 4645,
    entry_id: 87459,
    link: "https://burgerbegroting.be/topics/4645/entries/87459",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 33000,
    postcode: "2000",
    title: "Iedereen verdient een podium",
    description:
      "Heder vzw wil haar toneelzaal volledig toegankelijk maken voor mensen met een beperking uit hun eigen huis en uit de buurt.",
    image: "/projects/V Iedereen verdient een podium.jpg",
  },
  {
    id: "jeugdsamenkomsten-de-lekkerbek",
    topic_id: 4645,
    entry_id: 87415,
    link: "https://burgerbegroting.be/topics/4645/entries/87415",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 46956,
    postcode: "2018",
    title: "Jeugdsamenkomsten De lekkerbek",
    description:
      "De Lekkerbek organiseert kookactiviteiten voor kinderen van 7 tot 12 jaar. Ze stellen samen het menu op, doen boodschappen en koken onder begeleiding op zondag, woensdagnamiddag en tijdens schoolvakanties. Per sessie begeleiden 4 personen 2 groepen van telkens 20 kinderen. De focus ligt op koken, samenwerking, inspraak en praktische vaardigheden. Met 16.956€ personeelskost bij MCB vzw voor 2 jaar.",
    image: "/projects/V Jeugdsamenkomsten - De lekkerbek.jpg",
  },
  {
    id: "jongerenwerking-to-be-kiel",
    topic_id: 4645,
    entry_id: 87514,
    link: "https://burgerbegroting.be/topics/4645/entries/87514",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 29400,
    postcode: "2020",
    title: "Jongerenwerking to-be @Kiel",
    description:
      "​​Gekkoo wil op de lege verdieping van Gekkoo Kiel een jeugdwerking huisvesten. Vooraleer te kunnen verbouwen, is een grondige voorbereiding nodig. Alle nodige vergunningen (omgevingsvergunning, brandveiligheidsadvies, …) aanvragen en verkrijgen, ontwerpen en degelijk begroten van alle infrastructurele aanpassingen zijn vereist om er een veilige en reglementaire jeugdwerking onder te brengen. Met € 8.000 personeelskost.​",
    image: "/projects/V Jongerenwerking to-be @Kiel.jpg",
  },
  {
    id: "joy-up-animatie-aan-het-ziekenbed",
    topic_id: 4647,
    entry_id: 87460,
    link: "https://burgerbegroting.be/topics/4647/entries/87460",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 4900,
    postcode: DISTRICTSBREED,
    title: "Joy Up! Animatie aan het ziekenbed",
    description:
      "Een groep van een 40-tal vrijwilligers die zieken en gehandicapten zo‘n 80 keer gaan bezoeken. Dit gebeurt zowel thuis als in het ziekenhuis of bejaardenhuis. Ze brengen muziek mee en vrolijken de patiënten op met zang en dans. Zieke kinderen krijgen bovendien leuke cadeautjes. Met 1.600€ coördinatiekost.",
    image: "/projects/B Joy up, animatie aan het ziekenbed.jpg",
  },
  {
    id: "kathedraal-voltooid-met-licht",
    topic_id: 4648,
    entry_id: 87506,
    link: "https://burgerbegroting.be/topics/4648/entries/87506",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 100000,
    postcode: "2000",
    title: "Kathedraal Voltooid met Licht",
    description:
      "Na 500 jaar wordt de kathedraal 'afgewerkt' met licht. De droom: de tweede toren voltooien met drones en lasers. Een prachtig symbool voor het district, de stad en een visitekaartje voor de wereld.",
    image: "/projects/D Kathedraal Voltooid met Licht.jpg",
  },
  {
    id: "klappei-gaanderij",
    topic_id: 4645,
    entry_id: 87461,
    link: "https://burgerbegroting.be/topics/4645/entries/87461",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 55000,
    postcode: "2060",
    title: "Klappei Gaanderij",
    description:
      "De Klappeistraat wordt omgevormd tot de “Klappei Gaanderij”: een openluchtkunstgalerij waar bewoners en kunstenaars ramen, gevels, straat en het filmhuis zelf gebruiken om kunsten te tonen. Met 4 feesten in het jaar die een nieuw thema inluiden, en in samenwerking met lokale partners wil Filmhuis Klappei kunst zichtbaar maken en verbinding creëren tussen de buurt, culturen en generaties. De straat wordt een doorlopende tentoonstelling.",
    image: "/projects/V Klappei Gaanderij.jpg",
  },
  {
    id: "kleine-gelukswandelgids-voor-het-kiel",
    topic_id: 4647,
    entry_id: 86937,
    link: "https://burgerbegroting.be/topics/4647/entries/86937",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 6750,
    postcode: "2020",
    title: "Kleine gelukswandelgids voor het Kiel",
    description:
      "Een gids en bijhorend evenement maken het Kiel bekender en geliefder bij oude en nieuwe bewoners. Met een aantrekkelijke kaart ontdek je (verborgen) parels, stille groene plekjes, Wonderwoudjes en historische hotspots. Teksten verdiepen de band met de buurt, terwijl doe- en denkopdrachten het welbevinden van wandelaars stimuleren. Met 3.900€ coördinatiekost.",
    image: "/projects/B Kleine gelukswandelgids voor het Kiel.jpg",
  },
  {
    id: "kompanjon-aan-huis-studieondersteuning-in-wijken",
    topic_id: 4645,
    entry_id: 87529,
    link: "https://burgerbegroting.be/topics/4645/entries/87529",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 82098,
    postcode: "2020, 2050",
    title: "Kompanjon aan huis: studieondersteuning in wijken",
    description:
      "Kompanjon vzw begeleidt kinderen en jongeren in Kiel en Linkeroever bij schoolwerk, Nederlands en studievaardigheden, zodat ze succesvol naar school kunnen gaan. Het project versterkt ook samenwerking tussen ouders en school, ondersteunt belangrijke schoolovergangen en bouwt met gezinnen een sterk netwerk en zinvolle vrijetijdsbesteding uit. 76.198€ personeelskost voor 2 jaar. Met steun van de jeugdraad.",
    image: "/projects/V Kompanjon aan huis studieondersteuning in wijken.jpg",
  },
  {
    id: "kookhulp-kansarmoede",
    topic_id: 4645,
    entry_id: 87530,
    link: "https://burgerbegroting.be/topics/4645/entries/87530",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 94320,
    postcode: "2018",
    title: "Kookhulp kansarmoede",
    description:
      "Keren Belz vzw maakt kookhulp betaalbaar voor gezinnen/bejaarden die het echt nodig hebben. Zo kunnen ook zij regelmatig een gezonde maaltijd op tafel zetten en meer stabiliteit ervaren in hun dagelijks leven, waar dat anders niet mogelijk zou zijn. Met 20.000 EUR loonkost.",
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: "kopje-suiker",
    topic_id: 4647,
    entry_id: 86940,
    link: "https://burgerbegroting.be/topics/4647/entries/86940",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 7500,
    postcode: "2060",
    title: "Kopje Suiker",
    description:
      "Kopje Suiker brengt bewoners van 2060 samen tijdens vijf open ontmoetingsmomenten. Verhalen, vragen en ervaringen uit het dagelijks leven staan centraal: van feesten en eten tot opvoeding, zorg en samenleven. Dankzij warme begeleiding, actieve toeleiding en aandacht voor toegankelijkheid versterkt het project vertrouwen, ontmoeting en verbondenheid in de buurt, ook via de publicatie van een zine achteraf.",
    image: "/projects/B Kopje suiker.jpeg",
  },
  {
    id: "kwaliteitsvolle-schoolomgevingen",
    topic_id: 4645,
    entry_id: 87636,
    link: "https://burgerbegroting.be/topics/4645/entries/87636",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 122334,
    postcode: "2018, 2020, 2060",
    title: "Kwaliteitsvolle Schoolomgevingen",
    description:
      "​​Recht op Lucht vormt tien Antwerpse schoolstraten om tot kwaliteitsvolle, veilige schoolomgevingen. Kinderen en ouders kunnen elkaar ontmoeten in een groene, aangename omgeving. Schoolbestuur, leerkrachten, kinderen, ouders en omwonenden worden betrokken in het maken van een ontwerp en helpen bij het uitvoeren van eenvoudige ingrepen, zoals meer geveltuinen, bloembakken en zitbanken, en mooiere boomspiegels. € 45.334 personeelskost voor 2 jaar.",
    image: "/projects/V Kwaliteitsvolle schoolomgevingen.jpg",
  },
  {
    id: "lets-save-food-antwerpen",
    topic_id: 4645,
    entry_id: 87524,
    link: "https://burgerbegroting.be/topics/4645/entries/87524",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 60000,
    postcode: DISTRICTSBREED,
    title: "Let’s Save Food! - Antwerpen",
    description:
      "Let’s Save Food! gaat op een consequent duurzame wijze voedselverlies tegen door voedseloverschotten te verzamelen van diverse bronnen en ze via verdeelpunten op buurtniveau beschikbaar te stellen aan iedereen die ze kan en wil redden. Vrijwilligers halen onverkochte voeding van bv. grootwarenhuizen op per bakfiets. Herverdeling van meerdere tonnen voeding per week is het streefdoel. De samenwerking in de buurt versterkt ook sociale banden.",
    image: "/projects/V Lets_ Save Food.jpeg",
  },
  {
    id: "linkeroever-bastards-senioren-gaan-op-stap",
    topic_id: 4647,
    entry_id: 86950,
    link: "https://burgerbegroting.be/topics/4647/entries/86950",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 4000,
    postcode: "2050",
    title: "Linkeroever Bastards - senioren gaan op stap",
    description:
      "​​Linkeroever heeft weinig cultuuraanbod voor senioren. In Antwerpen zijn er verschillende leuke voorstellingen, soms op maat van senioren (ook matinées). Voor minder mobiele senioren is het moeilijk om met het openbaar vervoer naar de stad te gaan, en dat is jammer. Daarom huurt FV Helo 4x per jaar een bus om de senioren heen en weer naar een fijne voorstelling te brengen tot voor de deur.",
    image: "/projects/B Linkeroever Bastards - senioren gaan op stap.jpg",
  },
  {
    id: "lockerbankjes-straatmeubilair-met-opbergtwist",
    topic_id: 4647,
    entry_id: 87403,
    link: "https://burgerbegroting.be/topics/4647/entries/87403",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 7500,
    postcode: DISTRICTSBREED,
    title: "Lockerbankjes: straatmeubilair met opbergtwist",
    description:
      "Straatmeubilair met geïntegreerde opbergruimte, zoals een bank, wordt geplaatst in de publiek toegankelijke ruimte. Het meubel fungeert als zitplek en bevat onderaan een afsluitbare berging. Die kan dienen voor materiaal van pop-up straatfeesten en ontmoetingen, of als veilige opslagruimte voor buurtbewoners. Ook andere vormen van multifunctioneel straatmeubilair zijn mogelijk.",
    image: "/projects/B Lockerbankjes.jpg",
  },
  {
    id: "lucys-hub",
    topic_id: 4645,
    entry_id: 87468,
    link: "https://burgerbegroting.be/topics/4645/entries/87468",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 115000,
    postcode: "2018",
    title: "Lucy’s Hub",
    description:
      "Lucy’s Hub stelt verschillende ruimtes binnen Lucy’s Antwerp open voor de buurt. Ze dienen als atelier, werkplek of locatie voor workshops, bijeenkomsten en kleinschalige culturele activiteiten, gratis of tegen een kleine vergoeding. Het project versterkt de hub met een vaste coördinator en investeert in toegankelijkheid, comfort, veiligheid en voorzieningen. Met 80.000€ voor personeel tijdens 2 jaar.",
    image: "/projects/V Lucy_s Hub.jpg",
  },
  {
    id: "meer-groen-en-banken-in-de-karel-oomsstraat",
    topic_id: 4647,
    entry_id: 87507,
    link: "https://burgerbegroting.be/topics/4647/entries/87507",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 4000,
    postcode: "2018",
    title: "Meer groen en banken in de Karel Oomsstraat",
    description:
      "​​Er worden enkele bloembakken en zitbanken in de Karel Oomsstraat geplaatst en eventueel zwerfvuilnetten op het terrein van de school. Deze zorgen voor meer groen en ontmoeting.​",
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: "meer-plezier-voor-kids-en-ouders-op-elisabethplein",
    topic_id: 4647,
    entry_id: 87404,
    link: "https://burgerbegroting.be/topics/4647/entries/87404",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 7500,
    postcode: "2060",
    title: "Meer plezier voor kids en ouders op Elisabethplein",
    description:
      "Een verplaatsbare zitbank (parklet), aangevuld met kleurrijke grondtekeningen, nodigt kinderen en ouders uit tot spel, ontmoeting en verbinding in hun eigen omgeving rond het Elisabethplein.",
    image: "/projects/B Meer plezier voor kids en ouders op Elisabethplein.jpg",
  },
  {
    id: "meer-toekomstbomen-in-de-binnenstad",
    topic_id: 4648,
    entry_id: 87469,
    link: "https://burgerbegroting.be/topics/4648/entries/87469",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 270600,
    postcode: "2000",
    title: "Meer Toekomstbomen in de Binnenstad!",
    description:
      "​​Er komen extra toekomstbomen in de binnenstad, zowel door extra aanplant als door het aanpassen van de ondergrond voor bestaande bomen. Toekomstbomen zijn bomen die oud en groot mogen worden. Ze brengen meer groen, schaduw, en biodiversiteit dan kleinere bomen. We zetten in op het centrum met de Lambermontplaats, Marnixplaats, Theaterplein, Mechelseplein en het pleintje aan de Academie.",
    image: "/projects/D Meer Toekomstbomen in de Binnenstad.jpg",
  },
  {
    id: "minder-gras-en-meer-beplanting-op-de-luchtbal",
    topic_id: 4648,
    entry_id: 87640,
    link: "https://burgerbegroting.be/topics/4648/entries/87640",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 12000,
    postcode: "2030",
    title: "Minder gras en meer beplanting op de Luchtbal",
    description:
      "​Op Luchtbal is veel gazon aanwezig. Daarom wordt 100 m² gazon omgevormd tot een zone met middelhoge en hoge beplanting. Het project versterkt de biodiversiteit en brengt extra groen in de vorm van bomen, struiken en bloemen, wat bijdraagt aan een aantrekkelijkere en meer klimaatrobuuste leefomgeving.",
    image: "/projects/D Minder gras en meer beplanting op de Luchtbal.jpg",
  },
  {
    id: "nieuw-kippenhok-voor-de-buurt-hertsdeinstraat",
    topic_id: 4647,
    entry_id: 86981,
    link: "https://burgerbegroting.be/topics/4647/entries/86981",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 5000,
    postcode: "2018",
    title: "Nieuw kippenhok voor de buurt Hertsdeinstraat",
    description:
      "Op het terrein van Chiro Lore staat een groot buurtkippenhok met een achttal kippen. Het hok is verouderd en aan vervanging toe. De buurtbewoners willen het daarom zelf vernieuwen.",
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: "nieuwe-verbeeldingen-van-het-zeemanshuis",
    topic_id: 4645,
    entry_id: 87534,
    link: "https://burgerbegroting.be/topics/4645/entries/87534",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 49722,
    postcode: "2000",
    title: "Nieuwe verbeeldingen van het Zeemanshuis",
    description:
      "​​Club Zee vzw opent het oude zeemanshuis in de Italiëlei opnieuw en maakt ruimte voor artistieke en sociale ontmoetingen, geïnspireerd op verhalen uit het verleden, voor een nieuw publiek. Ze betrekken een breed publiek via een wekelijkse open inloop, het verzamelen van verhalen, een publieke programmatie, en het (gratis) delen van de ruimte. Thema’s als heimwee en koloniale geschiedenis worden onderzocht. Met € 30.700 personeelskost.",
    image: "/projects/V Nieuwe verbeeldingen van het Zeemanshuis.jpg",
  },
  {
    id: "on-the-road-een-mobiliteitsevent-voor-ouderen",
    topic_id: 4648,
    entry_id: 87508,
    link: "https://burgerbegroting.be/topics/4648/entries/87508",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 40000,
    postcode: DISTRICTSBREED,
    title: "On the road: een mobiliteitsevent voor ouderen",
    description:
      "Mobiliteit is voor senioren cruciaal om zelfstandig te blijven, sociale contacten te onderhouden en isolement te voorkomen. Alle vormen van vervoer zijn belangrijk: openbaar vervoer, fiets, auto, wandelen, alternatieven (riksja’s, taxi), … Daarom organiseert district Antwerpen op vraag van de seniorenraad een zevental infosessies en workshops op verschillende locaties, en een afsluitende themadag.",
    image: "/projects/D On the road, een mobiliteitsevent voor senioren.jpg",
  },
  {
    id: "ondersteuning-vrijwilligers-rond-mobiliteit",
    topic_id: 4648,
    entry_id: 87470,
    link: "https://burgerbegroting.be/topics/4648/entries/87470",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 64500,
    postcode: DISTRICTSBREED,
    title: "Ondersteuning vrijwilligers rond mobiliteit",
    description:
      "​​RiksjaRijden en de Markgravetandems tonen een grote nood bij mensen met beperkte mobiliteit. Een fietsrit trekt hun horizon weer open. In lokale herstelateliers leren vrijwilligers mensen in (kans)armoede hun eigen fiets te onderhouden (Centrum De Wijk, Buurtwerking Den Dam, Kauwenberg, de Markgrave, fietsbibs en anderen). Zij verdienen ondersteuning door deskundige fietstechniekers en vormingswerkers. Met € 16.000 personeelskost voor 2 jaar.",
    image: "/projects/D Ondersteuning vrijwilligers rond mobiliteit.jpg",
  },
  {
    id: "park-spoor-noord-verbeteren",
    topic_id: 4648,
    entry_id: 87364,
    link: "https://burgerbegroting.be/topics/4648/entries/87364",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 80000,
    postcode: "2060",
    title: "Park Spoor Noord verbeteren",
    description:
      "Dit voorstel versterkt Park Spoor Noord met een ecologische corridor, rijkere beplanting (meer bloembollen en heesters) en een kunstwerk. Zo wordt het duurzaam groene hart van Antwerpen verder uitgebouwd tot een plek waar iedereen welkom is en kan genieten van een aantrekkelijke, groene omgeving.",
    image: "/projects/D Park Spoor Noord verbeteren.jpg",
  },
  {
    id: "parkstraat-sint-amandusstraat",
    topic_id: 4648,
    entry_id: 87462,
    link: "https://burgerbegroting.be/topics/4648/entries/87462",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 187000,
    postcode: "2060",
    title: "Parkstraat Sint-Amandusstraat",
    description:
      "De Sint-Amandusstraat (tot Tulpstraat) wordt ingericht als groene en leefbare straat met meer beplanting, zitplekken en ruimte voor ontmoeting. Door de parkeerplaatsen in een andere richting te organiseren, ontstaat extra ruimte voor groen én wordt één bijkomende parkeerplaats gecreëerd. Het ontwerp richt zich op buurtbewoners, kinderen en voorbijgangers en stimuleert samenleven en vergroening.",
    image: "/projects/D Parkstraat Sint-Amandus.jpg",
  },
  {
    id: "participatieve-muurschildering",
    topic_id: 4648,
    entry_id: 87535,
    link: "https://burgerbegroting.be/topics/4648/entries/87535",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 50000,
    postcode: "2020",
    title: "Participatieve muurschildering",
    description:
      "De gevel van een gebouw op het Kiel krijgt een muurschildering. Een professionele graffitikunstenaar zet het werk op de muur. Voorafgaand is er een participatieproject met buurtbewoners en scholen. Anekdotes, verhalen, afbeeldingen en tekeningen vormen de inspiratie voor de muurschildering. Kunst voor en door de buurtbewoners!",
    image: "/projects/D Participatieve muurschildering.jpg",
  },
  {
    id: "peperfabriek-buurtkeuken-en-atelier",
    topic_id: 4645,
    entry_id: 87536,
    link: "https://burgerbegroting.be/topics/4645/entries/87536",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 105000,
    postcode: "2018",
    title: "Peperfabriek - buurtkeuken en -atelier",
    description:
      "Peperfabriek versterkt de buurt (2018) met een professionele sociale keuken en een nieuw publiek atelier. Een duurzame renovatie (dak, isolatie, ramen) en gereedschap zodat bewoners wekelijks gezond kunnen eten of zelf spullen kunnen herstellen. De inzet van vrijwilligers en een vaste coördinator bouwen aan een solidaire wijkplek waar ontmoeting en circulaire economie centraal staan voor alle bewoners. Met 60.000€ personeelskost voor 2 jaar.",
    image: "/projects/V Peperfabriek - buurtkeuken en -atelier.jpg",
  },
  {
    id: "pleintje-opfrissen-gloriantlaan",
    topic_id: 4648,
    entry_id: 87365,
    link: "https://burgerbegroting.be/topics/4648/entries/87365",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 11000,
    postcode: "2050",
    title: "Pleintje opfrissen Gloriantlaan",
    description:
      "De bewoners van de Gloriantlaan willen op het pleintje graag drie tafels en enkele banken plaatsen, met de mogelijkheid om parasols te gebruiken bij fel zonlicht. Er wordt ook bekeken of er een speltafel kan geplaatst worden.",
    image: "/projects/D Pleintje opfrissen Gloriantlaan.jpg",
  },
  {
    id: "poepke-zwam",
    topic_id: 4645,
    entry_id: 87601,
    link: "https://burgerbegroting.be/topics/4645/entries/87601",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 60000,
    postcode: "2060",
    title: "Poepke Zwam",
    description:
      "Dit project van Convoi Exceptionel vzw ontwikkelt een kweekruimte uit mycelium voor lokale experimenten gedurende 2 jaar. Een levend, mobiel labo biedt inzicht in onder- en bovengrondse netwerken en toepassingen van dit materiaal. De ruimte richt zich op mycologie in brede zin, met onderzoek, workshops en experimenten rond milieu, industrie, voeding, geneeskunde en kunst, in een open atelier voor bewoners, scholen en verenigingen.",
    image: "/projects/V Poepke Zwam.jpg",
  },
  {
    id: "poezieposters-in-heel-het-district",
    topic_id: 4647,
    entry_id: 87405,
    link: "https://burgerbegroting.be/topics/4647/entries/87405",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 7500,
    postcode: DISTRICTSBREED,
    title: "Poëzieposters in heel het district",
    description:
      "District Antwerpen wordt een poëziedistrict. 50 Gedichten verschijnen in verschillende vormen bij lokale organisaties zoals buurthuizen, wijkwerkingen, straatcomités en actieve vzw’s. Samen met deze partners wordt een plan over het hele jaar uitgewerkt, met acties op diverse locaties die poëzie zichtbaar maken in het straatbeeld.",
    image: "/projects/B Poëzieposters in heel het district.jpg",
  },
  {
    id: "provinciestraat-bomendreef",
    topic_id: 4648,
    entry_id: 87366,
    link: "https://burgerbegroting.be/topics/4648/entries/87366",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 407000,
    postcode: "2018",
    title: "Provinciestraat Bomendreef",
    description:
      "Bomen aanplanten en plantvakken aanleggen in de parkeerstrook van het brede deel van de Provinciestraat, als groene corridor tussen de Kerkstraat en het Giraffenplein. Dit helpt het hitte-eilandeffect verminderen en versterkt de biodiversiteit en leefbaarheid in de stationsbuurt. In dit grijze straatdeel van ongeveer 250 meter staat nu slechts één boom. De brede straat, met parkeren aan beide zijden, biedt ruimte voor extra bomen en groen.",
    image: "/projects/D Provinciestraat als Bomendreef.jpg",
  },
  {
    id: "qi-gong-regatta",
    topic_id: 4647,
    entry_id: 86982,
    link: "https://burgerbegroting.be/topics/4647/entries/86982",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 700,
    postcode: "2050",
    title: "Qi Gong Regatta",
    description:
      "Een jaar lang wekelijkse Qi Gong-lessen voor 55-plussers in Sporthal Linkeroever aan de Blancefloerlaan. Qi Gong combineert rustige bewegingen, ademhaling en ontspanning om lichaam en geest in balans te brengen. De lessen bevorderen vitaliteit, verminderen stress en ondersteunen het mentale en fysieke welzijn.",
    image: "/projects/B Qi Gong Regatta.jpg",
  },
  {
    id: "renovatie-van-het-kiekenkot-van-de-spilkiekens",
    topic_id: 4647,
    entry_id: 87406,
    link: "https://burgerbegroting.be/topics/4647/entries/87406",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 6185,
    postcode: "2060",
    title: "Renovatie van het kiekenkot van de Spilkiekens",
    description:
      "Het kippenhok van de spilkiekens in de samentuin van het Zusters-der-Armenplein is tot op de draad versleten. Een aannemer renoveert de huidige container: gaten dichten, nieuw dak, deur, raam en regenpijp… Gevolgd door een feestje met de buurt als de renovatie compleet is.",
    image: "/projects/B Renovatie van het kiekenkot van de Spilkiekens.jpg",
  },
  {
    id: "riksja-verbindt-met-blind-dates-extra-stallingen",
    topic_id: 4645,
    entry_id: 87509,
    link: "https://burgerbegroting.be/topics/4645/entries/87509",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 142750,
    postcode: DISTRICTSBREED,
    title: "Riksja verbindt met Blind Dates & extra stallingen",
    description:
      "Riksja Blind Date brengt mensen die kampen met isolement en eenzaamheid samen. Diverse organisaties creëren 200 verrassende, warme ontmoetingen tussen blinden, ouderen en mensen met een beperking. Zo versterkt Axivzw hun sociale netwerk en vergroot hun zelfredzaamheid. Er worden extra riksja’s en stallingen voorzien, vooral op Linkeroever, Luchtbal en Kiel. Personeelskost: 15.000€ voor 2 jaar.",
    image: "/projects/V RiksjaRijden Blind Date en extra stallingen.jpg",
  },
  {
    id: "ringland-in-zicht-ontwerp-jouw-park-op-de-ring",
    topic_id: 4645,
    entry_id: 87537,
    link: "https://burgerbegroting.be/topics/4645/entries/87537",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 99000,
    postcode: "2000, 2018, 2020",
    title: "Ringland in zicht – ontwerp jouw park op de Ring",
    description:
      "De overkapping tussen Borgerhout en de Kennedytunnel wordt nu ontworpen. Ter hoogte van Merksem en de Oosterweeltunnel is dat gebeurd mét inbreng van burgers. Ringland trekt de straat op in 7 wijken, organiseert feestelijke buurtevents, leidt lokale vrijwilligers op als buurtantennes en zorgt dat burgers hun stem echt meetelt aan de ontwerptafels. 70.000€ personeelskost voor 2 jaar.",
    image: "/projects/V Ringland in zicht.jpeg",
  },
  {
    id: "route-2060",
    topic_id: 4645,
    entry_id: 87538,
    link: "https://burgerbegroting.be/topics/4645/entries/87538",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 12700,
    postcode: "2060",
    title: "ROUTE 2060",
    description:
      "Met Route 2060 wil Elegast vzw de sociale cohesie in de wijk 2060 versterken door thematische wijkwandelingen. Oude en nieuwe bewoners gaan acht keer samen op pad en ontdekken zo op een laagdrempelige manier het rijke erfgoed, de diversiteit, het aanbod en de organisaties in hun buurt. De routemappen zullen op verschillende locaties in 2060 gratis te verkrijgen zijn. Met 7.700€ personeelskost.",
    image: "/projects/V Route 2060.jpg",
  },
  {
    id: "ruis-verbindend-stadsfestival",
    topic_id: 4645,
    entry_id: 87471,
    link: "https://burgerbegroting.be/topics/4645/entries/87471",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 72500,
    postcode: "2000",
    title: "RUIS – Verbindend Stadsfestival",
    description:
      "2 Gratis muziek- & cultuurfestivals op unieke plekken in de stad (horeca, handelszaken, kunstplekken, openbare ruimte...) met een focus op lokaal talent. De verschillende culturele organisaties die Antwerpen rijk is, werken mee aan het programma. Eersteklas vzw creëert speelkansen, verbindt horeca, makers en bewoners en versterkt de broodnodige cultuur en community die onze stad rijk en uniek maakt. Met 26.000€ personeelskost in 2 jaar.",
    image: "/projects/V RUIS - Verbindend Stadsfestival.jpg",
  },
  {
    id: "schaaktafels-in-het-stadspark",
    topic_id: 4648,
    entry_id: 87456,
    link: "https://burgerbegroting.be/topics/4648/entries/87456",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 33000,
    postcode: "2018",
    title: "Schaaktafels in het Stadspark",
    description:
      "4 hoogwaardige schaaktafels met bankjes in het Stadspark, waar iedereen met eigen schaakstukken kan spelen.",
    image: "/projects/D Schaaktafels in het Stadspark.jpg",
  },
  {
    id: "schuilhokje-op-noordschippersdok",
    topic_id: 4648,
    entry_id: 87367,
    link: "https://burgerbegroting.be/topics/4648/entries/87367",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 15000,
    postcode: "2060",
    title: "Schuilhokje op Noordschippersdok",
    description:
      "Aan het Noordschippersdok komt een nieuw houten schuilhokje als ontmoetingsplek voor jong en oud. Het biedt ruimte om te zitten, spelen, schuilen en babbelen. Vooraf vinden twee inspraakmomenten plaats, waarbij buurtbewoners samen met de bouwer kunnen nadenken over het ontwerp en de inrichting.",
    image: "/projects/D Schuilhokje op Noordschippersdok.jpg",
  },
  {
    id: "seniorengids-op-papier-publicatie-en-verdeling",
    topic_id: 4648,
    entry_id: 87455,
    link: "https://burgerbegroting.be/topics/4648/entries/87455",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 8500,
    postcode: DISTRICTSBREED,
    title: "Seniorengids op papier: publicatie en verdeling",
    description:
      "​​De seniorengids, die al online bestaat, verschijnt ook op papier voor wie minder digitaal vaardig is of liever op papier leest. Zo is de info makkelijk te raadplegen in dienstencentra, bibliotheken en het districtshuis. Op aanvraag wordt de gids per post verstuurd. Zo wordt de dienstverlening toegankelijker en vinden senioren vlotter hun weg in de stad.​ Dit is een idee van de seniorenraad.",
    image: "/projects/D Seniorengids op papier opmaak en verdeling.jpg",
  },
  {
    id: "sporttoestellen-in-openlucht-op-luchtbal",
    topic_id: 4648,
    entry_id: 87368,
    link: "https://burgerbegroting.be/topics/4648/entries/87368",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 110000,
    postcode: "2030",
    title: "Sporttoestellen in openlucht op Luchtbal",
    description:
      "Sporttoestellen op enkele plekken in openlucht op Luchtbal zodat mensen outdoor en ook zonder fitnessabonnement kunnen trainen.",
    image: "/projects/D Sporttoestellen in openlucht op Luchtbal.jpg",
  },
  {
    id: "stadsuitstappengids-samen-op-stap",
    topic_id: 4645,
    entry_id: 87539,
    link: "https://burgerbegroting.be/topics/4645/entries/87539",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 7500,
    postcode: DISTRICTSBREED,
    title: "Stadsuitstappengids Samen Op Stap",
    description:
      "Cult&Comedy organiseert minstens 5 gegidste stadsuitstappen naar musea en historische plekken in de stad voor minstens 15 ouderen met een migratieachtergrond, uit moskeeën of afkomstig uit kwetsbare doelgroepen. Deze doelgroep heeft ondersteuning nodig voor meer stads- en cultuurbeleving. Met deze uitstappen (her)ontdekken de ouderen de stad en worden ze via deze beleving na hun migratie erkend. Met 4.100€ personeelskost.",
    image: "/projects/V Stadsuitstappengids Samen Op Stap.jpg",
  },
  {
    id: "stap-per-stap",
    topic_id: 4645,
    entry_id: 87548,
    link: "https://burgerbegroting.be/topics/4645/entries/87548",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 86800,
    postcode: "2000",
    title: "Stap per Stap",
    description:
      "Centrum Kauwenberg vzw wil de competenties versterken van mensen met een grote afstand tot de arbeidsmarkt, gekoppeld aan een Rap op Stap-kantoor met bar (Kauwenbar). Deelnemers krijgen de kans hun talenten te ontdekken en ontwikkelen, van administratie en onthaal tot catering. Met 50.000€ voor personeel in 2 jaar.",
    image: "/projects/V Stap per Stap.jpg",
  },
  {
    id: "sterke-vrijwilligers-van-unik-en-2018",
    topic_id: 4645,
    entry_id: 87416,
    link: "https://burgerbegroting.be/topics/4645/entries/87416",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 45700,
    postcode: "2018",
    title: "Sterke vrijwilligers van Unik en 2018",
    description:
      "Bij Buurthuis Unik zetten vrijwilligers met diverse achtergronden en kwetsbaarheden zoals een fysieke beperking, psychische kwetsbaarheid, autisme, blindheid en verslavingen zich actief in. Dit project wil hen verder laten floreren via toegankelijke vormingen voor alle vrijwilligers uit postcode 2018, een prikkelarme ruimte en inclusieve aanpassingen aan het vrijwilligersbeleid en de werking van Unik. Met 40.400€ personeelskost in 2 jaar.",
    image: "/projects/V Sterke vrijwilligers van Unik en 2018.jpg",
  },
  {
    id: "stoelzumba-senioren-linkeroever",
    topic_id: 4648,
    entry_id: 87369,
    link: "https://burgerbegroting.be/topics/4648/entries/87369",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 6600,
    postcode: "2050",
    title: "Stoelzumba senioren Linkeroever",
    description:
      "Wegens groot succes verlengd: stoelzumba! Senioren komen elke week samen in het dienstencentrum om te sporten en te bewegen.",
    image: "/projects/D Stoelzumba senioren Linkeroever.jpg",
  },
  {
    id: "stormkring-op-de-zandbank-expressie-zondagen",
    topic_id: 4645,
    entry_id: 87323,
    link: "https://burgerbegroting.be/topics/4645/entries/87323",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 15820,
    postcode: "2030",
    title: "Stormkring - Op de Zandbank, expressie-zondagen",
    description:
      "​​“Op de Zandbank”, het festival rond mentale kwetsbaarheid van Stormkop en de Keerkring/Emmaüs, is al jaren een vaste waarde. Tijdens expressie-zondagen werken deelnemers van de Keerkring, anderstalige nieuwkomers van het VL(o)OT-project en hun begeleiders samen toe naar een gezamenlijke voorstelling op het festival. Met €16.300 personeelskost.",
    image: "/projects/V Stormkring - Op de Zandbank, expressie-zondagen.jpg",
  },
  {
    id: "straatwerken-voorbereiding-artistieke-braderij",
    topic_id: 4645,
    entry_id: 87540,
    link: "https://burgerbegroting.be/topics/4645/entries/87540",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 7650,
    postcode: "2000",
    title: "Straatwerken - voorbereiding artistieke braderij",
    description:
      "Moonsick vzw doet enerzijds de voorbereidingen voor een artistieke braderij tijdens Antwerp Art Weekend. Anderzijds werken ze aan een netwerk tussen handelaars en bewoners rond de Lange Koepoortstraat en de Oude Beurs. Met 6.000€ personeelskost.",
    image: "/projects/V Straatwerken - voorbereiding artistieke braderij.jpg",
  },
  {
    id: "taalkruid",
    topic_id: 4647,
    entry_id: 86983,
    link: "https://burgerbegroting.be/topics/4647/entries/86983",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 6130,
    postcode: "2000",
    title: "Taalkruid",
    description:
      "Poëzie in de Kruidentuin! Van mei tot september klinkt op 8 zondagen poëzie tussen de planten en bomen van de Kruidentuin in het hart van Antwerpen. Telkens planten andere TaalTuiniers tere poëzieplantjes en wieden het onkruid, om het woord tot volle bloei te laten komen. Een uitnodiging voor elke Antwerpenaar om te luisteren, te ontdekken en een vers (gesproken) poëzieplantje mee naar huis te nemen.",
    image: "/projects/B Taalkruid.jpg",
  },
  {
    id: "terras-met-bediening-door-mensen-met-down",
    topic_id: 4645,
    entry_id: 87541,
    link: "https://burgerbegroting.be/topics/4645/entries/87541",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 75000,
    postcode: "2050",
    title: "Terras met bediening door mensen met een beperking",
    description:
      "De Fromentinstraat aan de jachthaven van Linkeroever is prachtig gelegen en vele fietsers en voetganger passeren daar. Samen met personen met een verstandelijke beperking, van het Katrinahof, wordt dit pleintje omgebouwd tot een groot terras. Bewoners en passanten kunnen elkaar daar perfect ontmoeten.",
    image: "/projects/V Terras met bediening door mensen met Down.jpg",
  },
  {
    id: "tuinstraat-inspiratiestraat",
    topic_id: 4645,
    entry_id: 87513,
    link: "https://burgerbegroting.be/topics/4645/entries/87513",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 22380,
    postcode: "2020",
    title: "Tuinstraat - Inspiratiestraat",
    description:
      "Wat gebeurt er als je je straat vergroent en buren dichter bij elkaar brengt? Herbeleef mee de zomer van 2017, toen de Pieter Génardstraat een experimentele tuinstraat was. Verwacht je twee weken lang aan inspirerende sprekers, een ‘monument’ in de straat, een natuurwandeling, een fietsatelier en een feesttafel. Doel: het potentieel van een straat tonen. Het investeringsbudget komt nadien de buurt ten goede. Met 3.780€ personeelskost.",
    image: "/projects/V Tuinstraat - Inspiratiestraat.jpg",
  },
  {
    id: "tussen-woord-en-vorm",
    topic_id: 4647,
    entry_id: 87379,
    link: "https://burgerbegroting.be/topics/4647/entries/87379",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 2500,
    postcode: "2018",
    title: "Tussen Woord en Vorm",
    description:
      "Dit project brengt buurtbewoners samen rond kunst, landschap en de poëzie van Paul van Ostaijen. Zijn werk vormt de inspiratie voor hedendaagse schilderijen en een interactieve installatie. Woorden worden zichtbaar, kleur krijgt ritme en betekenis. Zo ontstaat een gedeelde artistieke ervaring die ontmoeting, verbeelding en participatie stimuleert.",
    image: "/projects/B Tussen Woord en Vorm.jpg",
  },
  {
    id: "tussenstap-vzw-ontmoetingshuis-antwerpen",
    topic_id: 4645,
    entry_id: 87643,
    link: "https://burgerbegroting.be/topics/4645/entries/87643",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 149966,
    postcode: "2030",
    title: "Tussenstap VZW - Ontmoetingshuis Antwerpen",
    description:
      "​​​​Tussenstap vzw creëert een ontmoetingshuis voor jongvolwassenen die herstellen van een ernstige ziekte, aandoening of ingrijpende gebeurtenis. Via ontmoeting, een buddywerking en samenwerking met lokale verenigingen ontdekken deelnemers opnieuw hun talenten en mogelijkheden en zetten ze stap voor stap de weg verder naar vrijwilligerswerk, participatie en een nieuw perspectief. Met €74.668 personeelskost voor 2 jaar.",
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: "unik-iedereen-welkom",
    topic_id: 4645,
    entry_id: 87542,
    link: "https://burgerbegroting.be/topics/4645/entries/87542",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 39800,
    postcode: "2018",
    title: "UNIK - Iedereen welkom",
    description:
      "Buurthuis UNIK is er vóór en dóór buurtbewoners. Iedereen is welkom. Maar het gebouw volstaat niet om écht iedereen welkom te heten: het is verstopt achter een kleine deur, de zalen zijn niet rolstoeltoegankelijk, er is schimmel en vocht, de brandveiligheid en toegankelijkheid zijn niet in orde voor mensen met een beperking,… UNIK wil het gebouw zo aanpassen zodat het een plek kan zijn waar iedereen zich welkom voelt. Met 8.000€ personeelskosten.",
    image: "/projects/V UNIK - Iedereen Welkom.jpg",
  },
  {
    id: "voedsel-en-kledingbedeling-luchtbal",
    topic_id: 4647,
    entry_id: 86986,
    link: "https://burgerbegroting.be/topics/4647/entries/86986",
    category: CATEGORIES.BEWONERSIDEE,
    budget: 7500,
    postcode: "2030",
    title: "Voedsel- en kledingbedeling Luchtbal",
    description:
      "De lokale en kleinschalige voedsel- en kledingbedeling voor de wijk Luchtbal breidt na twee jaar verder uit. Thuisleveringen bij mensen die zelf niet naar de werking kunnen komen, zijn mogelijk. Het budget is voor de aankoop van voedsel, het opzetten van samenwerkingen, een diepvriezer, een kast en kledingrekken. Uitvoering door De Maatschappij fv.",
    image: "/projects/B Voedsel- en kledingbedeling Luchtbal.jpg",
  },
  {
    id: "women-healing-empowerment-hub-2060",
    topic_id: 4645,
    entry_id: 87644,
    link: "https://burgerbegroting.be/topics/4645/entries/87644",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 150000,
    postcode: "2020, 2030, 2060",
    title: "Women Healing & Empowerment Hub 2060",
    description:
      "​​​Women Healing & Empowerment Hub 2060 richt zich op vrouwen uit de Soedanese, Eritrese, Yemenitische en Somalische diaspora in 2060, 2020 en 2030. Op basis van hun noden en op hun uitnodiging delen lokale organisaties toegankelijke kennis. Maatschappelijke informatie wordt zo begrijpbaar en toepasbaar voor alle deelnemers én er ontstaat duurzame verbinding tussen gemeenschappen en buurt. Met € 45.000 personeelskost voor 2 jaar. Door Elhikma2060. ",
    image: "/projects/V Women Healing & Empowerment Hub 2060.jpg",
  },
  {
    id: "zakelijke-ondersteuning-voor-cultuursector",
    topic_id: 4648,
    entry_id: 87641,
    link: "https://burgerbegroting.be/topics/4648/entries/87641",
    category: CATEGORIES.DISTRICTSIDEE,
    budget: 150000,
    postcode: "2000, 2060",
    title: "Zakelijke ondersteuning voor cultuursector",
    description:
      "Het district voorziet een zakelijke medewerker die kleine vzw’s met een residentiewerking ondersteunt bij onder meer subsidiedossiers, het kunstenaarsstatuut en facturatie. Zo worden organisaties en residenten administratief ontlast, waardoor meer ruimte ontstaat voor een sterk cultuurprogramma en een duurzame artistieke praktijk. Dit versterkt zowel de werking van culturele organisaties als de ondersteuning van kunstenaars. Idee van cultuurraad.",
    image: "/projects/D Zakelijke ondersteuning voor cultuursector.jpg",
  },
  {
    id: "dyard-culturen-verbinden-in-antwerpen",
    topic_id: 4645,
    entry_id: 80448,
    link: "https://burgerbegroting.be/topics/4645/entries/80448",
    category: CATEGORIES.VERENIGINGSIDEE,
    budget: 44000,
    postcode: "2030, 2060",
    title: "D’Yard - Culturen verbinden in Antwerpen",
    description:
      "Antwerpen is heel divers maar echte ontmoetingen tussen de verschillende gemeenschappen blijven beperkt. D’Yard brengt daar verandering in: een jaar lang brengen we bewoners samen rond eten, muziek en dialoog. Geen eenmalig evenement, maar een traject dat uitmondt in een bruisend festival en tot blijvende verbinding leidt in Luchtbal en Antwerpen Noord. Met € 15.000 personeelskost.",
    image: "/projects/V D’Yard - Culturen verbinden in Antwerpen.JPG",
  },
];
